import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome } from '~/core/styleTypes';

export const SideBySideStatContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
`;

export const StatContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
`;

export const StatName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
    flex: 2;
    text-align: center;
`;

export const StatValue = styled.div<WithIsHome>`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
    flex: 1;
    text-align: ${({ $isHome }) => ($isHome ? 'right' : 'left')};
`;

export const RankValue = styled.div<WithIsHome>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
    flex: 1;
    text-align: ${({ $isHome }) => ($isHome ? 'right' : 'left')};
`;
